<template>
  <div>
    <ts-card class="m-t-10">
      <ts-card-wrapper>
        <div class="d-flex justify-content-end">
          <div class="d-flex">
            <ts-input
              v-model="search"
              :placeholder="$t('search')"
              style="width: 250px;"
              class="inline-block"
            />
            <ts-button
              outline
              class="ml-2"
              v-tooltip="$t('filter')"
              @click.prevent="visible = true"
            >
              <i class="fa fa-filter"></i>
            </ts-button>
          </div>
        </div>
        <!-- drawer -->
        <a-drawer
          :title="$t('filter')"
          placement="right"
          :closable="false"
          :visible="visible"
          @close="onCloseDrawer"
          :zIndex="1020"
          width="300px"
        >
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label class="ts-text-xs">{{ $t('homePage.dateRange') }}</label>
                <a-range-picker
                  format="DD-MM-YYYY"
                  :defaultValue="rangeDate"
                  :defaultPickerValue="rangeDate"
                  @change="dateRangeChange"
                >
                  <template slot="renderExtraFooter"></template>
                </a-range-picker>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label class="ts-text-xs">{{
                  $t('homePage.notificationType')
                }}</label>
                <treeselect
                  :options="
                    notificationTypes.map(el => ({
                      id: el.not_type_id,
                      label: el.not_type
                    }))
                  "
                  :placeholder="$t('all')"
                  :multiple="true"
                  :limit="1"
                  v-model="not_type_id"
                  @input="fetchData"
                />
              </div>
            </div>
          </div>
        </a-drawer>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table
          :columns="columns"
          :records="resources"
          :loading="loading"
          :rowGroup="{
            field: 'notification_type'
          }"
        >
          <template v-slot="{ record }">
            <td class="ts-whitespace-no-wrap">
              {{ record.notification_subject }}
            </td>
            <td class="ts-whitespace-no-wrap text-center">
              {{ record.activated_type }}
            </td>
            <td class="ts-whitespace-no-wrap">
              <div
                v-if="
                  record.notification_content
                    ? record.notification_content.length < 50
                    : true
                "
                v-html="record.notification_content"
              ></div>
              <div
                v-tooltip="record.notification_content"
                v-else
                v-html="record.notification_content.substring(0, 50) + '...'"
              ></div>
            </td>
            <td class="ts-whitespace-no-wrap text-center">
              {{ record.sent_time }}
            </td>
            <td class="ts-whitespace-no-wrap text-center">
              {{ record.finish_time }}
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { debounce } from 'lodash'
import moment from 'moment'

export default {
  name: 'parentNotificationHistory',
  data() {
    return {
      loading: false,
      visible: false,
      rangeDate: [moment().add(-1, 'Month'), moment()]
    }
  },
  created() {
    this.fetchResource()
  },
  computed: {
    ...mapState('home/parentNotificationHistory', [
      'resources',
      'pagination',
      'notificationTypes'
    ]),
    search: {
      get() {
        return this.$store.state.home.parentNotificationHistory.search
      },
      set(newVal) {
        this.$store.commit('home/parentNotificationHistory/SET_SEARCH', newVal)
        this.$store.commit('home/parentNotificationHistory/RESET_CURRENT_PAGE')
      }
    },
    not_type_id: {
      get() {
        return this.$store.state.home.parentNotificationHistory.not_type_id
      },
      set(newVal) {
        this.$store.commit(
          'home/parentNotificationHistory/SET_NOT_TYPE_ID',
          newVal
        )
      }
    },
    columns() {
      return [
        { name: this.$t('homePage.subject') },
        {
          name: this.$t('homePage.activatedType'),
          style: 'text-align: center'
        },
        { name: this.$t('homePage.content') },
        { name: this.$t('homePage.sentDate'), style: 'text-align: center' },
        { name: this.$t('homePage.finishDate'), style: 'text-align: center' }
      ]
    }
  },
  methods: {
    fetchResource() {
      this.$store
        .dispatch('home/parentNotificationHistory/fetchResource')
        .then(() => {
          this.fetchData()
        })
    },
    onCloseDrawer() {
      this.visible = false
    },
    fetchData(attributes) {
      this.loading = true

      this.$store
        .dispatch('home/parentNotificationHistory/fetch', attributes)
        .then(() => (this.loading = false))
        .catch(() => {
          this.loading = false
        })
    },
    dateRangeChange(dateRange) {
      this.$store.commit(
        'home/parentNotificationHistory/SET_DATE_FROM',
        dateRange[0].format('DD-MM-YYYY')
      )
      this.$store.commit(
        'home/parentNotificationHistory/SET_DATE_TO',
        dateRange[1].format('DD-MM-YYYY')
      )
      this.fetchData()
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  }
}
</script>
